/**
 * Mock data for the Member Dashboard.
 *
 * This mirrors the response shape from the member-dashboard API:
 *   GET /api/member?email=<email>
 *
 * When the real API is wired up, replace the mock import in dashboard.js
 * with a fetch call to the dashboard API endpoint.
 */

const mockDashboardData = {
  pike13_member: {
    person_id: 12345,
    name: 'John Smith',
    email: 'john@example.com',
    tenant_id: 1,
    gym_name: 'Starting Strength Austin',
    subdomain: 'ssaustin',
    has_membership: true,
    gender: 'male',
    birth_date: '1988-05-15',
  },
  has_membership: true,
  logbook: {
    id: 1,
    email: 'john@example.com',
    name: 'John Smith',
    tenant_id: 1,
    gym_name: 'Starting Strength Austin',
    first_workout_date: '2024-06-01',
    last_workout_date: '2026-04-03',
    total_workouts: 180,
    workouts_per_week: 3.2,
    total_pounds_lifted: 1250000,
    gender: 'male',
    birth_date: '1988-05-15',
    is_active_member: true,
    squat_weight: 315,
    bench_weight: 225,
    press_weight: 155,
    deadlift_weight: 365,
    squat_day1: 135,
    squat_day30: 185,
    squat_day60: 225,
    squat_day90: 265,
    bench_day1: 115,
    bench_day30: 155,
    bench_day60: 185,
    bench_day90: 205,
    press_day1: 75,
    press_day30: 105,
    press_day60: 125,
    press_day90: 140,
    deadlift_day1: 185,
    deadlift_day30: 245,
    deadlift_day60: 295,
    deadlift_day90: 335,
  },
  leaderboard: [
    { exercise: 'squat', rank: 3, total_in_gym: 45, weight: 315 },
    { exercise: 'bench', rank: 8, total_in_gym: 45, weight: 225 },
    { exercise: 'press', rank: 5, total_in_gym: 42, weight: 155 },
    { exercise: 'deadlift', rank: 2, total_in_gym: 45, weight: 365 },
  ],
  comparison: [
    { lift: 'squat', member_weight: 315, p25: 185, p50: 245, p75: 315, n: 120 },
    { lift: 'bench', member_weight: 225, p25: 145, p50: 185, p75: 235, n: 118 },
    { lift: 'press', member_weight: 155, p25: 95, p50: 125, p75: 155, n: 110 },
    { lift: 'deadlift', member_weight: 365, p25: 225, p50: 295, p75: 365, n: 115 },
  ],
  pike13: {
    person_id: 12345,
    subdomain: 'ssaustin',
    tenure: {
      total_membership_days: 540,
      member_since: '2024-06-01',
      current_plans: [
        { plan_name: '3x/week Membership', start_date: '2024-06-01', is_on_hold: false },
      ],
    },
    upcoming_sessions: [
      {
        event_name: 'Group Class',
        service_date: '2026-04-07',
        start_at: '2026-04-07T09:00:00',
        instructor_names: 'Coach Anderson',
      },
      {
        event_name: 'Group Class',
        service_date: '2026-04-09',
        start_at: '2026-04-09T09:00:00',
        instructor_names: 'Coach Martinez',
      },
      {
        event_name: 'Group Class',
        service_date: '2026-04-11',
        start_at: '2026-04-11T10:00:00',
        instructor_names: 'Coach Anderson',
      },
    ],
  },
  streak: 12,
};

export default mockDashboardData;
